import Axios from 'axios';
import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';
import { stringNumberToBoolean } from '@ts/utils/funcs';

export function fetch(params = {}, rest = {}) {
    return axios.get('/activity', { params, ...rest }).then(({ data }) => {
        if (data && typeof data === 'object' && Array.isArray(data.items)) {
            return data;
        }
        throw new ApiRequestError('Failed fetch activities: /activity', { params, rest });
    });
}

export function fetchConfig(params = {}, rest = {}) {
    return axios.get('/config', { params, ...rest }).then(({ data }) => {
        if (data && typeof data === 'object') {
            return data;
        }
        throw new ApiRequestError('Failed fetch config: /config', { params, rest });
    });
}

export function fetchRecommends(params = {}, rest = {}) {
    return axios.get('/activity/recommended', { params, ...rest }).then(({ data }) => {
        if (data && typeof data === 'object' && Array.isArray(data.items)) {
            return data.items;
        }
        throw new ApiRequestError('Failed fetchRecommends activities: /activity/recommended', {
            params,
            rest,
        });
    });
}

export function fetchPreviewById(id, params = {}, rest = {}) {
    return axios
        .get(`/activity/${id}/no-cache`, {
            params,
            ...rest,
        })
        .then(({ data }) => {
            if (
                typeof data === 'object' &&
                Array.isArray(data.items) &&
                data.items[0] &&
                typeof data.items[0] === 'object'
            ) {
                return data.items[0];
            }

            throw new ApiRequestError('Failed fetchById activities: /activity', {
                id,
                params,
                rest,
            });
        })
        .then((activity) => {
            const parsedActivity = (() => {
                const obj = activity;
                try {
                    return {
                        ...obj,
                        data: typeof obj.data === 'string' ? JSON.parse(obj.data) : undefined,
                    };
                } catch (err) {
                    console.log(new Error(`${err.message}: ${id}`));
                    // should not cause the display to fail
                    return obj;
                }
            })();

            return parsedActivity;
        });
}
export function fetchById(id, params = {}, rest = {}) {
    return fetch({ id, ...params }, rest)
        .then((data) => {
            if (data.items[0] && typeof data.items[0] === 'object') {
                return data.items[0];
            }

            throw new ApiRequestError('Failed fetchById activities: /activity', {
                id,
                params,
                rest,
            });
        })
        .then((activity) => {
            const parsedActivity = (() => {
                const obj = activity;
                try {
                    return {
                        ...obj,
                        data: typeof obj.data === 'string' ? JSON.parse(obj.data) : undefined,
                    };
                } catch (err) {
                    console.log(new Error(`${err.message}: ${id}`));
                    // should not cause the display to fail
                    return obj;
                }
            })();

            return parsedActivity;
        });
}

export function fetchAvailabilityById(id, params = {}, rest = {}) {
    return axios
        .get('/activity/availability', {
            params: {
                id,
                ...params,
            },
            ...rest,
        })
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return {
                    ...data,
                    use_calendar: stringNumberToBoolean(data.use_calendar),
                    use_schedule: stringNumberToBoolean(data.use_schedule),
                };
            }

            throw new ApiRequestError(
                'Failed fetchAvailabilityById activities: /activity/availability',
                id,
                params,
                rest
            );
        });
}

export function fetchAvailabilityMonthById(id, params = {}, rest = {}) {
    return axios
        .get('/activity/availability/month', {
            params: {
                activity_id: id,
                ...params,
            },
            ...rest,
        })
        .then(({ data }) => {
            if (Array.isArray(data)) {
                return data;
            }
            throw new ApiRequestError(
                'Failed fetchAvailabilityMonthById activities: /activity/availability/month',
                id,
                params,
                rest
            );
        });
}

export function fetchByItineraryId(id, params = {}, rest = {}) {
    return fetch({ itinerary_id: id, ...params }, rest);
}

export function fetchUserImagesById(id) {
    const rootImage = process.env.BUILD_ENV !== 'prod' ? 'image-staging' : 'image';
    return Axios.get(`https://api.tripshock.com/${rootImage}/photo?activity_id=${id}`).then(
        ({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError('Failed fetchUserImagesById activities: /activity', id);
        }
    );
}

export function fetchUserImagesInSearch(activity_ids) {
    const rootImage = process.env.BUILD_ENV !== 'prod' ? 'image-staging' : 'image';
    return Axios.get(
        `https://api.tripshock.com/${rootImage}/photo/excerpt?activity_ids=${activity_ids}`
    ).then(({ data }) => {
        if (data && typeof data === 'object') {
            return data;
        }
        console.log('Failed fetchUserImagesInSearch attractions: /attractions', activity_ids);
    });
}
